import * as React from "react";
import { Query } from "react-apollo";
import { Helmet } from "react-helmet";
import { Row, Col, Button } from "reactstrap";
import { withToastManager } from "react-toast-notifications";

// GraphQL
import GetUserDetails from "../../GraphQL/Queries/GetUserDetails";

// Presentation/UI
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import Loader from "../../Components/Loader/DotLoader";
import GlobalModal from "../../Components/GlobalModal";

import AddAssetForm from "./AddAssetForm";
import AllAssets from "./AllAssets";

// Utils
import { getUserId } from "../../Utils/Helpers";

const userId = getUserId().userId;

interface IProps {
  toastManager: any;
}

class Assets extends React.Component<IProps> {
  state = {
    modal: false
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (): void => {
    this.setState({
      modal: true
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    return (
      <Query query={GetUserDetails} variables={{ id: userId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the assets</div>;
          }

          const companyId = data.User.company.id;

          return (
            <BackendWrapper>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Add Asset"
                modalDisplay={
                  <AddAssetForm
                    companyId={companyId}
                    closeModal={this.closeModal}
                    notification={this.toastNotification}
                  />
                }
                modal={this.state.modal}
              />
              <Row>
                <Col xs={12} md={2} lg={2}>
                  <Button onClick={() => this.openModal()}>Add Asset</Button>
                </Col>
              </Row>
              <br />
              <br />
              <AllAssets
                companyId={companyId}
                toastManager={this.props.toastManager}
              />
              <Helmet title="Assets" />
            </BackendWrapper>
          );
        }}
      </Query>
    );
  }
}

export default withToastManager(Assets);



// WEBPACK FOOTER //
// ./src/Containers/Assets/index.tsx